import { useSurveyContext } from '../../../_store'

const useMultiSelect = ({ component, step }) => {
  const { state, dispatch, actions } = useSurveyContext()
  const { formData } = state.pages[`step_${step}`]
  const { maxSelections: max, slug: componentSlug } = component

  const selectOpt = (option) => {
    dispatch({
      type: 'setAnswer',
      payload: {
        [componentSlug]: [...formData[componentSlug], option.slug]
      }
    })
  }

  const deselectOpt = (option) => {
    dispatch({
      type: 'setAnswer',
      payload: {
        [componentSlug]: [
          ...formData[componentSlug].filter((obj) => obj !== option.slug)
        ]
      }
    })
  }

  const handleSelect = (option, handleDeselect) => {
    if (handleDeselect) {
      if (option === handleDeselect) {
        if (!formData[componentSlug].includes(handleDeselect.slug)) {
          dispatch({
            type: 'setAnswer',
            payload: {
              [componentSlug]: [option.slug]
            }
          })
        } else {
          dispatch({
            type: 'setAnswer',
            payload: {
              [componentSlug]: []
            }
          })
        }
      } else {
        let data = [
          ...formData[componentSlug].filter(
            (obj) => obj !== handleDeselect.slug
          ),
          option.slug
        ]
        if (formData[componentSlug].includes(option.slug)) {
          data = data.filter((e) => e !== option.slug)
        }

        dispatch({
          type: 'setAnswer',
          payload: {
            [componentSlug]: data
          }
        })
      }
    } else {
      if (formData[componentSlug].includes(option.slug)) {
        // remove option from currently selected state
        deselectOpt(option)
        actions.error(null)
      } else {
        // user wants to add option to currently selected state.
        if (max && typeof max === 'number') {
          // If we have set a max, check if they can add the option to the selected array.
          if (formData[componentSlug].length < max) {
            selectOpt(option)
          } else {
            // Show max error
            actions.error(
              `You may only select up to ${max}. Please deselect an option to choose a different answer.`
            )
          }
        } else {
          selectOpt(option)
        }
      }
    }
  }

  const isSelected = (option) => {
    return formData[componentSlug].findIndex((opt) => opt === option.slug) !==
      -1
      ? true
      : false
  }

  return [isSelected, handleSelect]
}

export default useMultiSelect
